
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M11.999 21.998a3.004 3.004 0 01-2.124-.875l-.73-.73a1.504 1.504 0 00-1.064-.439H7.054a3.015 3.015 0 01-3.011-3.01v-1.029a1.509 1.509 0 00-.44-1.065l-.718-.717a3.015 3.015 0 01-.011-4.257l.73-.73c.282-.284.438-.663.439-1.065V7.055a3.015 3.015 0 013.011-3.012h1.028c.401 0 .779-.156 1.064-.44l.719-.718a3.014 3.014 0 014.257-.01l.73.73c.284.282.662.438 1.063.438h1.028a3.015 3.015 0 013.011 3.012v1.027c.001.401.157.78.44 1.065l.718.718c.569.566.884 1.32.887 2.125.002.8-.306 1.553-.867 2.122l-.029.03-.71.71a1.504 1.504 0 00-.439 1.064v1.027a3.015 3.015 0 01-3.011 3.011h-1.028c-.401.001-.78.157-1.064.44l-.719.718c-.586.59-1.36.886-2.133.886z","fill":"#D0021B"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.043 10.05a.856.856 0 01-.616.255.903.903 0 01-.615-.255.88.88 0 01-.26-.62c0-.218.092-.442.254-.615a.792.792 0 01.3-.194.856.856 0 01.942.193.833.833 0 01.264.616.84.84 0 01-.27.62zm5.148-1.24a.878.878 0 00-1.238 0l-5.14 5.14a.877.877 0 00.62 1.494.868.868 0 00.617-.256l5.14-5.14a.877.877 0 000-1.238zm-.285 4.954a.885.885 0 00-.964.194 1.176 1.176 0 00-.18.27.85.85 0 00-.06.342.845.845 0 00.25.622.896.896 0 00.625.253c.222 0 .44-.09.619-.257a.865.865 0 00.246-.618.864.864 0 00-.247-.62.798.798 0 00-.29-.186z","fill":"#D0021B"}})])
          )
        }
      }
    